const FLAGS_BASE_URL = `${process.env.PUBLIC_URL || ''}/assets/flags`

const CUSTOM_MAPPINGS = {
  en: 'EN',
  tr: 'TR'
}

const FALLBACK_FLAG = `${FLAGS_BASE_URL}/DefaultFlag.png`

export const getFlagSrc = (code) => {
  if (!code) return FALLBACK_FLAG

  const normalized = CUSTOM_MAPPINGS[code.toLowerCase()] || code.toUpperCase()
  return `${FLAGS_BASE_URL}/${normalized}.png`
}

export const getDefaultFlag = () => FALLBACK_FLAG